"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Badge_1 = require("./Badge");
exports.default = Badge_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Badge/index.js
// module id = 1035
// module chunks = 8